import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getPigletFootprintByYear, getPigletFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_PIGLET } from "consts";

export const useGetFootprintingPigletFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  // User context hook returns `null` on admin for whatever reason
  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_PIGLET, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getPigletFootprintByYearAdmin(farmId ?? "", year) : getPigletFootprintByYear(year)),
      enabled:
        enabled &&
        carbonProgram?.platformFeatures?.footprinting?.enabled &&
        carbonProgram.platformFeatures.footprinting.pork === true &&
        !!farmId &&
        !!year &&
        isLoggedIn,
      queryClient,
      gcTime: 60000,
    })),
  });
};
